import { render, staticRenderFns } from "./main-practice-areas.vue?vue&type=template&id=682ddec0&scoped=true"
import script from "./main-practice-areas.vue?vue&type=script&lang=js"
export * from "./main-practice-areas.vue?vue&type=script&lang=js"
import style0 from "./main-practice-areas.vue?vue&type=style&index=0&id=682ddec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ddec0",
  null
  
)

export default component.exports